import { Navigate, Outlet, useParams } from "react-router";
import { isValidLang } from "@/config/routes";
import { useAuth } from "@/contexts/auth-context";
import type { User } from "@/types/auth";

type FlagGuardProps = {
	predicate: (user: User) => boolean;
};

export function FlagGuard({ predicate }: FlagGuardProps) {
	const { user } = useAuth();
	const { lang } = useParams<{ lang: string }>();
	const currentLang = lang && isValidLang(lang) ? lang : "pl";

	if (!user || !predicate(user)) {
		return <Navigate to={`/${currentLang}/`} replace />;
	}

	return <Outlet />;
}
